import { FC, ReactNode } from "react";

interface DataTableProps<T> {
    items: T[];
    headers: string[];
    renderRow: (item: T, idx?: number) => JSX.Element;
    stickyHeader?: boolean;
}

export const DataTable = <T,>({ items, headers, stickyHeader, renderRow }: DataTableProps<T>) => {
    return (
        <table className={`table table-zebra w-full  ${stickyHeader ? "table-pin-rows" : ""}`}>
            <thead>
                <tr>
                    {
                        headers.map((header, index) => (
                            <th key={index}>{header}</th>
                        ))
                    }
                </tr>
            </thead>
            <tbody>
                {items.map((item, i) => renderRow(item, i))}
            </tbody>
        </table>
    );
};
